function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M310.68 31.29L335.17 31.29L335.2 369.89L310.7 369.9L310.68 31.29Z",
  id: "b16FVLLKJG"
}), /*#__PURE__*/React.createElement("path", {
  d: "M324.12 15.31L341.73 32.92L230.38 144.29L212.76 126.67L324.12 15.31Z",
  id: "h2zppFiqHw"
}), /*#__PURE__*/React.createElement("path", {
  d: "M307.72 31.67L325.13 14.44L435.93 126.37L418.51 143.6L307.72 31.67Z",
  id: "a2t6obnxDF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M100.85 200.59L125.35 200.59L125.35 607.34L100.85 607.34L100.85 200.59Z",
  id: "c5Het3jB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M110.66 582.42L534.7 582.44L534.7 607.34L110.66 607.33L110.66 582.42Z",
  id: "a8snGOWDVm"
}), /*#__PURE__*/React.createElement("path", {
  d: "M522.45 200.59L546.95 200.59L546.95 607.34L522.45 607.34L522.45 200.59Z",
  id: "fvxZkzeKy"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.32 200.59L274.76 200.59L274.76 225.5L104.32 225.5L104.32 200.59Z",
  id: "fmyBQLbwN"
}), /*#__PURE__*/React.createElement("path", {
  d: "M368.8 200.59L539.24 200.72L539.22 225.63L368.78 225.5L368.8 200.59Z",
  id: "a2jEEeXfEm"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b16FVLLKJG",
  opacity: 1,
  fill: "#00445e",
  fillOpacity: 1
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#h2zppFiqHw",
  opacity: 1,
  fill: "#00445e",
  fillOpacity: 1
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a2t6obnxDF",
  opacity: 1,
  fill: "#00445e",
  fillOpacity: 1
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c5Het3jB",
  opacity: 1,
  fill: "#00445e",
  fillOpacity: 1
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a8snGOWDVm",
  opacity: 1,
  fill: "#00445e",
  fillOpacity: 1
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#fvxZkzeKy",
  opacity: 1,
  fill: "#00445e",
  fillOpacity: 1
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#fmyBQLbwN",
  opacity: 1,
  fill: "#00445e",
  fillOpacity: 1
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a2jEEeXfEm",
  opacity: 1,
  fill: "#00445e",
  fillOpacity: 1
}))));

var SvgShare = function SvgShare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/share.8362bd02.svg";
export { ForwardRef as ReactComponent };